<template>
  <div class="component product-cart-item">
    <div class="quantity-container" v-if="!item.details.percentageType">
      <quantity-picker :min="1" :max="item.details.percentageType ? 1 : undefined" v-model="item.quantity" @input="updateProductQuanity" :active="qtyActive" v-if="editable"/>
      <span v-else>{{ item.quantity }}</span>
      <span class="price">{{ displayPrice }}</span>
    </div>
    <div v-else></div>
    <div class="subtotal">{{ $formatter.currency(item.total) }}</div>
  </div>
</template>

<script>
import Cart from '@/models/Cart';
import QuantityPicker from '@/components/QuantityPicker.vue';

export default {
  props: {
    item: Object,
    editable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      productQuantity: this.item.quantity,
      qtyActive: true
    };
  },

  computed: {
    displayPrice() {
      let displayPrice = "";

      if(this.item.details.percentageType) {
        displayPrice = this.item.details.price + "%";
      } else {
        displayPrice = this.$formatter.currency(this.item.details.price);
      }

      return displayPrice;
    },
  },

  methods: {
    updateProductQuanity() {
      this.qtyActive = false;
      Cart.update(this.item).then(() => {
        this.qtyActive = true;
      });
    }
  },

  components: {
    QuantityPicker
  }
}
</script>

<style lang="scss">
.component.product-cart-item {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;

  .quantity-container {
    display: flex;
    align-items: center;
    margin: 0 10px 5px 0;
  }

  .quantity-picker {
    width: auto;
    max-width: 100px;
    min-width: 85px;
    margin-bottom: 0;
  }

  .price {
    &::before {
      content: "\00d7";
      margin: 0 10px;
    }
  }

  .subtotal {
    @include font-h2;
  }
}
</style>